<section
  class="page_404 h-100 d-flex justify-content-center align-items-center">
  <div class="container">
    <div class="row">
      <div class="col-md-12 d-flex justify-content-center align-items-center">
        <div class="col-sm-10 col-sm-offset-1 text-center">
          <div class="four_zero_four_bg"></div>

          <div class="contant_box_404">
            <h3 class="h2">Site under maintenance</h3>

            <p>the page you are looking for not avaible!</p>

            <button
              mat-flat-button
              color="primary"
              class="btn-ultra-compact"
              (click)="goBackToHome()">
              Go back to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
